import { apiClient } from "../lib/api";

export const recruitmentApi = {
  listJobs: (status) => apiClient.get("/recruitment/jobs", { params: { status: status || undefined } }),
  getJob: (id) => apiClient.get(`/recruitment/jobs/${id}`),
  createJob: (payload) => apiClient.post("/recruitment/jobs", payload),
  updateJob: (id, payload) => apiClient.patch(`/recruitment/jobs/${id}`, payload),
  setJobStatus: (id, status, closureReason) => apiClient.post(`/recruitment/jobs/${id}/status`, { status, closure_reason: closureReason || undefined }),

  listApplicants: (jobPostingId, status) => apiClient.get("/recruitment/applicants", { params: { job_posting_id: jobPostingId || undefined, status: status || undefined } }),
  getApplicant: (id) => apiClient.get(`/recruitment/applicants/${id}`),
  addApplicantNote: (id, note) => apiClient.post(`/recruitment/applicants/${id}/notes`, { note }),
  setApplicantStatus: (id, status, reason) => apiClient.post(`/recruitment/applicants/${id}/status`, { status, reason }),

  listInterviewSlots: (jobPostingId, status) => apiClient.get("/recruitment/interview-slots", { params: { job_posting_id: jobPostingId || undefined, status: status || undefined } }),
  createInterviewSlot: (payload) => apiClient.post("/recruitment/interview-slots", payload),
  cancelInterviewSlot: (id, reason) => apiClient.post(`/recruitment/interview-slots/${id}/cancel`, { reason }),

  uploadHeroImage: (jobId, file) => {
    const data = new FormData();
    data.append("file", file);
    return apiClient.post(`/recruitment/jobs/${jobId}/hero-image`, data, { headers: { "Content-Type": "multipart/form-data" } });
  },
  removeHeroImage: (jobId) => apiClient.delete(`/recruitment/jobs/${jobId}/hero-image`),

  downloadResume: (id) => apiClient.get(`/recruitment/applicants/${id}/resume`, { responseType: "blob" }),
  convertToApplication: (id) => apiClient.post(`/recruitment/applicants/${id}/convert-to-application`),
};
